export enum State {
  DEFAULT = 'default',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success'
}
